import {
  ButtonLinkProps,
  ButtonProps,
  ButtonVariant,
} from './types'

const baseClasses =
  'inline-flex min-h-11 cursor-pointer items-center justify-center rounded-[36px] px-6 py-3 font-heading text-base font-bold leading-5 text-lightning-yellow-950 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-lightning-yellow-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-black-100 disabled:text-black-700'

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-lightning-yellow-500 active:bg-lightning-yellow-600',
  secondary: 'bg-white-50 active:bg-lightning-yellow-600',
  outline:
    'border border-white-950 bg-transparent text-white-950 active:bg-lightning-yellow-600',
}

export function Button({
  children,
  variant = 'primary',
  className = '',
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`${baseClasses} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}

export function ButtonLink({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ButtonLinkProps) {
  return (
    <a
      className={`${baseClasses} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </a>
  )
}
